module.exports = __webpack_public_path__ + "img/AceDiamond.f37d608f.png";